import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useCurrency } from '../../../../hooks/useCurrency';
import Divider from '../../../../components/misc/divider';
import PieChart from '../../../../components/blocks/pieChart';
import ConfirmButton from '../../../../components/buttons/confirmButton';
import IncrementButton from '../../../../components/buttons/increment';
import { getNumberCorrectSuffix } from '../../../../localization';

const SplitBillDivide = ({ table, order, onConfirm }) => {
  const { currencySymbol } = useCurrency();
  const { t } = useTranslation();

  const [payFor, setPayFor] = useState(1);
  const [atTable, setAtTable] = useState(2);

  const percent = (payFor / atTable) * 100;

  const orderTotal =
    (order.price || {}).leftToPay > 0 ? order.price.leftToPay : (order.price || {}).total || 0;
  const toPayTotal = orderTotal * (percent / 100);

  return (
    <div className="">
      <div className="flex justify-center">
        <PieChart percent={Math.trunc(percent)} />
      </div>
      <div className="mt-3">
        <p className="font-primaryMedium text-base text-bland text-center">
          {t('common.tableNo')} {table.number}
        </p>
      </div>
      <Divider className="mt-4" />
      <div className="my-7">
        <div className="flex flex-row justify-between items-center">
          <p className="font-primaryMedium text-base text-primary mr-2">
            {t(`checkout.dividePayForPerson_${getNumberCorrectSuffix(payFor)}`, {
              payForAmount: payFor,
            })}
          </p>
          <IncrementButton min={1} max={atTable} value={payFor} onChange={setPayFor} />
        </div>
        <div className="flex flex-row justify-between items-center mt-5">
          <p className="font-primaryMedium text-base text-primary mr-2">
            {t(`checkout.divideAtTheTable`, { atTableAmount: atTable })}
          </p>
          <IncrementButton
            min={1}
            value={atTable}
            onChange={(val) => {
              setAtTable(val);
              if (val < payFor) {
                setPayFor(val);
              }
            }}
          />
        </div>
      </div>
      <Divider className="mb-7" />
      <div className="flex flex-row justify-between items-center">
        <p className="font-primaryMedium text-base text-bland">{t('checkout.totalBill')}</p>
        <p className="font-primaryMedium text-base text-bland">
          {orderTotal.toFixed(2)} {currencySymbol}
        </p>
      </div>
      <div className="flex flex-row justify-between items-center mt-2">
        <p className="font-primaryMedium text-xl text-primary">{t('checkout.youArePaying')}</p>
        <p className="font-primaryMedium text-xl text-primary">
          {toPayTotal.toFixed(2)} {currencySymbol}
        </p>
      </div>
      <ConfirmButton
        onClick={() => {
          const parsedAmount = parseFloat(toPayTotal);
          onConfirm(Number.isNaN(parsedAmount) ? 0 : parsedAmount);
        }}
        disabled={!toPayTotal}
      />
    </div>
  );
};

export default SplitBillDivide;
